import { Button, FormControl, TextField } from "@material-ui/core";
import {
  PASSWORD_POLICY_HINT,
  passwordMeetsPolicy
} from "../modules/passwordPolicy";
import FormError, { useError } from "./FormError";

import _ from "lodash";
import api from "../api";
import { makeStyles } from "@material-ui/core/styles";
import { useState } from "react";

const useStyles = makeStyles((theme) => ({
  submitButton: {
    marginTop: theme.spacing(3)
  }
}));

export default function ChangePasswordForm({
  onSuccess,
  submitLabel = "Change password"
}) {
  const classes = useStyles();
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formMessage, setFormMessage] = useError();

  const policyOk = passwordMeetsPolicy(newPassword);
  const matchesCurrent =
    Boolean(newPassword) && newPassword === currentPassword;
  const confirmMismatch =
    Boolean(confirmNewPassword) && confirmNewPassword !== newPassword;

  const canSubmit =
    Boolean(currentPassword) &&
    policyOk &&
    !matchesCurrent &&
    Boolean(confirmNewPassword) &&
    !confirmMismatch &&
    !isSubmitting;

  function newPasswordHelperText() {
    if (matchesCurrent)
      return "New password must be different from your current password.";

    return PASSWORD_POLICY_HINT;
  }

  function onSubmit(e) {
    e.preventDefault();
    setFormMessage("");
    if (!canSubmit) return;

    setIsSubmitting(true);
    return api
      .changePassword({ currentPassword, newPassword })
      .then(api.pickData)
      .then(() => {
        onSuccess();
      })
      .catch((error) => {
        let errorMsg;
        if (_.get(error, "response.status") === 401)
          errorMsg =
            _.get(error, "response.data.error.message") ||
            "Your current password is incorrect.";

        // 422 (policy violation) and any other error fall through to
        // <FormError>, which surfaces the server's error message for
        // sub-500 responses and masks 5xx to a generic message.
        setFormMessage(errorMsg || error);
        setIsSubmitting(false);
      });
  }

  return (
    <form noValidate onSubmit={onSubmit}>
      <FormControl margin="normal" required fullWidth>
        <TextField
          label="Current password"
          required
          type="password"
          variant="outlined"
          autoComplete="current-password"
          value={currentPassword}
          onChange={(e) => setCurrentPassword(e.target.value)}
        />
      </FormControl>
      <FormControl margin="normal" required fullWidth>
        <TextField
          label="New password"
          required
          type="password"
          variant="outlined"
          autoComplete="new-password"
          value={newPassword}
          error={Boolean(newPassword) && (!policyOk || matchesCurrent)}
          helperText={newPasswordHelperText()}
          onChange={(e) => setNewPassword(e.target.value)}
        />
      </FormControl>
      <FormControl margin="normal" required fullWidth>
        <TextField
          label="Confirm new password"
          required
          type="password"
          variant="outlined"
          autoComplete="new-password"
          value={confirmNewPassword}
          error={confirmMismatch}
          helperText={confirmMismatch ? "Passwords do not match." : ""}
          onChange={(e) => setConfirmNewPassword(e.target.value)}
        />
      </FormControl>
      <FormError error={formMessage} resetError={setFormMessage} />
      <Button
        className={classes.submitButton}
        fullWidth
        type="submit"
        size="large"
        variant="contained"
        color="primary"
        disabled={!canSubmit}
      >
        {submitLabel}
      </Button>
    </form>
  );
}
